import React, { useState } from 'react';
import { useI18n } from '../useI18n.js';
import { Avatar } from './Avatar';

export function GuessZone({ phase, guessOptions, hasGuessed, selectedGuess, onGuess, avatarMap = {}, nameMap = {} }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  if (phase !== 'thinking') return null;

  const list = (
    <div>
      <div style={{ marginBottom: '0.5rem', fontSize: '0.85rem', color: '#374151', fontWeight: 600 }}>
        {t('chooseAuthorHint')}
      </div>
      {guessOptions.map(u => {
        const display = nameMap[u] || u;
        return (
          <button
            key={u}
            disabled={hasGuessed}
            onClick={() => onGuess(u)}
            className={`guess-button${
              hasGuessed && selectedGuess === u ? ' guess-selected' : ''
            }`}
          >
            <Avatar url={avatarMap[u]} label={display} className="guess-img" size={40} />
            {display}
          </button>
        );
      })}
    </div>
  );

  return (
    <div style={{ marginTop: '1rem' }}>
      {/* Desktop/tablette: liste inline */}
      <div className="guess-list-desktop">
        {list}
      </div>

      {/* Mobile: bouton fixe + bottom sheet */}
      <button
        type="button"
        className="guess-toggle-btn"
        onClick={() => setOpen(o => !o)}
        disabled={hasGuessed}
        aria-expanded={open}
        aria-controls="guess-bottom-sheet"
      >
        {open ? t('hideGuesses') : t('showGuesses')}
      </button>
      {open && (
        <div id="guess-bottom-sheet" className="guess-bottom-sheet">
          {list}
        </div>
      )}
    </div>
  );
}
